import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";

class StandKitsApi extends baseApi {

    getOne = async (id) => {
        return await this.get(`?app=standkits&act=getOne&id=${id}`)
    }

    getList = async (data) => {
        return await this.post('?app=standkits&act=getList', data)
    }

    save = async (data) => {
        return await this.post('?app=standkits&act=save', {data: JSON.stringify(data)})
    }

    delete = async (id) => {
        return await this.post('?app=standkits&act=setDeleted', {id})
    }
}

export default new StandKitsApi(constants.DEBUG ? constants.base_url_stage : constants.base_url_prod);
